import React from 'react';
import './App.css';
import Header from './components/header/Header'

function App() {
  return (
    <div className="App">
      <Header />
    </div>
  );
}

export default App;